import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-work-list-timer',
  standalone: false,
  templateUrl: './work-list-timer.component.html',
  styleUrl: './work-list-timer.component.css',
})
export class WorkListTimerComponent {
  @Input() progress: number = 0;
  @Input() itemsLength: number = 0;

  // total elapsed duration in seconds (can come from API)
  @Input() workDuration: number | null = 0;
  @Output() workDurationChange = new EventEmitter<number>();

  private timerId: any = null;
  isPaused = false;

  ngOnInit(): void {
    this.workDuration ??= 0;
    this.startTimer();
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  /** Start / Resume timer */
  private startTimer(): void {
    if (this.timerId) return; // ⛔ prevent multiple intervals

    this.isPaused = false;

    this.timerId = setInterval(() => {
      this.workDuration!++;
      this.workDurationChange.emit(this.workDuration!);
    }, 1000);
  }

  /** Pause timer */
  private stopTimer(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    this.isPaused = true;
  }

  /** Toggle pause/resume */
  toggleTimer(): void {
    this.isPaused ? this.startTimer() : this.stopTimer();
  }

  /** Time formatter (HH:mm:ss) */
  formatTime(seconds: number | null): string {
    if (seconds == null) return '00:00:00';

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
  }

  private pad(num: number): string {
    return num < 10 ? `0${num}` : num.toString();
  }
}
